import { UserPlus } from "lucide-mui";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useState } from "react";
import { useOrgMembers } from "../../hooks/resources.ts";
import NoSelectionPrompt from "../../components/NoSelectionPrompt.tsx";
import OrgInvitationsList from "../../components/OrgInvitationsList.tsx";
import OrgInviteDialog from "../../components/OrgInviteDialog.tsx";
import OrgMembersTable from "../../components/OrgMembersTable";
import { userHasOrgScope } from "../../auth/scopes";
import { useAuth } from "../../contexts/AuthContext.tsx";
import { useOrganization } from "../../contexts/OrganizationContext.tsx";
import PageHeader from "../../components/PageHeader.tsx";

function MembersPage() {
  const { user } = useAuth();
  const { selectedOrgId, currentOrg } = useOrganization();
  const isOrgAdmin = userHasOrgScope(user, selectedOrgId, "org:manage_members");
  const [inviteOpen, setInviteOpen] = useState(false);

  const { data: members } = useOrgMembers(selectedOrgId);

  if (!selectedOrgId) {
    return (
      <Box>
        <PageHeader title="Members" />
        <NoSelectionPrompt kind="org" />
      </Box>
    );
  }

  const orgName = currentOrg?.name ?? "this organization";
  const count = members ? ` · ${members.length} ${members.length === 1 ? "member" : "members"}` : "";

  return (
    <Box>
      <PageHeader
        title="Members"
        description={`Who can access ${orgName} and what they can do${count}`}
        actions={
          isOrgAdmin && (
            <Button variant="contained" startIcon={<UserPlus />} onClick={() => setInviteOpen(true)}>
              Invite people
            </Button>
          )
        }
      />
      <OrgMembersTable
        organizationId={selectedOrgId}
        canManage={isOrgAdmin}
        canManageGroups={userHasOrgScope(user, selectedOrgId, "org:manage_groups")}
      />
      {isOrgAdmin && <OrgInvitationsList organizationId={selectedOrgId} />}
      <OrgInviteDialog
        open={inviteOpen}
        onClose={() => setInviteOpen(false)}
        organizationId={selectedOrgId}
        organizationName={currentOrg?.name}
      />
    </Box>
  );
}

export default MembersPage;
